var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xinnengyuan/%E5%A4%AA%E9%98%B3%E8%83%BD%E7%94%B5%E6%B1%A0%E7%89%87%E5%85%A5%E8%8A%B1%E7%AF%AE.mp4",
                    'title':"视觉引导太阳能电池片入花篮",
                    'lable':"散料太阳能电池片经传送带输送至工业相机下方，通过视觉系统定位、识别、检测，将OK/NG指令及位置信号传递给机器人，并由机械手定点跟踪、分类抓取、放至指定花篮中。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80片/min"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        }
                    ]
                }
            ]
        },
        {
            'name':"并联机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xinnengyuan/%E6%9F%B1%E7%8A%B6%E7%94%B5%E6%B1%A0%E5%88%86%E6%8B%A3%E5%B7%A5%E4%BD%9C%E7%AB%99.mp4",
                    'title':"柱状电池分拣工作站",
                    'lable':"生产完成的柱状电池整托经传送带输送至分拣工作站工业相机下方，通过视觉系统定位、识别、检测，并由机械手定点跟踪、抓取，将不同电池放至对应工位并由螺旋输送机输出，进入人工装盒环节，自动化工序完成",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度160支/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/ngz.png",
                            'title':"负载15公斤"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工4人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升200%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期15个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"自动上料"
                        },
                        {
                            'icon':"/static/case/jyjc.png",
                            'title':"极压检测"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"分级放置"
                        },
                        {
                            'icon':"/static/case/cl.png",
                            'title':"自动输出"
                        },
                        {
                           'icon':"/static/case/cl.png",
                           'title':"装盒"
                       },

                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xinnengyuan/%E6%96%B0%E8%83%BD%E6%BA%90%E7%94%B5%E6%B1%A0%E6%9E%81%E7%89%87%E5%88%86%E6%8B%A3%E5%B7%A5%E4%BD%9C%E7%AB%99.mp4",
                    'title':"新能源电池极片分拣工作站",
                    'lable':"刷粉机刷粉完成的极片经传送带输送至工业相机下方，通过视觉瑕疵检测机构定位、识别、检测，将OK/NG指令及位置信号传递给机器人，机器人根据信号定点高速跟踪、抓取，定点放置，实现高速、高精度叠片。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度90片/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转精度±0.1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工3人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期18个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/sf.png",
                            'title':"刷粉"
                        },
                        {
                            'icon':"/static/case/xcjc.png",
                            'title':"瑕疵检测"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉定位"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人分拣分级放置"
                        },
                        {
                           'icon':"/static/case/cl.png",
                           'title':"叠片输出"
                       },

                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xinnengyuan/%E7%94%B5%E6%B1%A0%E9%93%9D%E5%A3%B3%E5%88%86%E6%8B%A3%E6%8F%92%E8%8A%B1%E7%AF%AE.mp4",
                    'title':"电池铝壳分拣插花篮",
                    'lable':"电池铝壳经冲压机出料后，由传送带输送至工业相机下方，通过视觉系统定位、识别、检测，并由机械手定点跟踪、抓取、放至固定位置机构，同步翻转入花篮，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度110片/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转精度±0.1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工3人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"冲压机输出"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉定位"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人分拣分级放置"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"旋转竖立插盘"
                        }

                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/xinnengyuan/%E5%A4%AA%E9%98%B3%E8%83%BD%E7%94%B5%E6%B1%A0%E7%89%87%E5%85%A5%E8%8A%B1%E7%AF%AE.mp4",
                    'title':"太阳能电池片入花篮",
                    'lable':"散料太阳能电池片经传送带输送至工业相机下方，通过视觉系统定位、识别、检测，将OK/NG指令及位置信号传递给机器人，并由机械手定点跟踪、分类抓取、放至指定花篮中。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80片/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"旋转精度±0.1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升50%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期15个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"电池片输出"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉定位"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人分拣"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"整托回收"
                        }

                    ]
                },
            ]
        }       
    ],
    name:"新能源",
    title:"solutions",
    subtitle:"新能源行业应用案例",
    subinfo:"我们的应用案例包括为新能源电池提供生产环节中分拣、上下料、视觉识别等。",
}

export default {
    industryInfo
  };    


// WEBPACK FOOTER //
// ./src/data/industryInfo/11.js